import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminDepartmentService } from '@/modules/department/services/admin-department.service'
import { DepartmentRequestModel } from '@/modules/department/models/department-request.model'

@vservice()
export class AdminDepartmentUpdateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminDepartmentService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(departmentId: number, data: DepartmentRequestModel) {
    return this.service.updateDepartment(departmentId, data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
